export const PHONE_DISPLAY = "324 5855343";
export const PHONE_TEL = "tel:+393245855343";
export const WHATSAPP_URL =
  "https://wa.me/393245855343?text=" +
  encodeURIComponent(
    "Buongiorno Alberto, vorrei un'analisi gratuita dei costi del mio POS."
  );

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1787551415595-40cf928e1b08?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxwYXltZW50JTIwdGVybWluYWwlMjBjYWZlJTIwY291bnRlcnxlbnwwfHx8fDE3OTE0NTcwOTh8MA&ixlib=rb-4.1.0&q=85",
  diagnosi1:
    "https://images.unsplash.com/photo-1648201637025-1c77b9be3013?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBkb2N1bWVudCUyMGNhbGN1bGF0b3IlMjBwZW58ZW58MHx8fHwxNzkxNDU3MDk4fDA&ixlib=rb-4.1.0&q=85",
  diagnosi2:
    "https://images.unsplash.com/photo-1611125832047-1d7ad1e8e48f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxmaW5hbmNpYWwlMjBkb2N1bWVudCUyMGNhbGN1bGF0b3IlMjBwZW58ZW58MHx8fHwxNzkxNDU3MDk4fDA&ixlib=rb-4.1.0&q=85",
  diagnosi3:
    "https://images.unsplash.com/photo-1642043175009-5997b3a078d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxmaW5hbmNpYWwlMjBkb2N1bWVudCUyMGNhbGN1bGF0b3IlMjBwZW58ZW58MHx8fHwxNzkxNDU3MDk4fDA&ixlib=rb-4.1.0&q=85",
  settoreA:
    "https://images.unsplash.com/photo-1556742031-c6961e8560b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxyZXRhaWwlMjBjYXJkJTIwcGF5bWVudCUyMHRhcHxlbnwwfHx8fDE3OTE0NTcwOTh8MA&ixlib=rb-4.1.0&q=85",
  settoreB:
    "https://images.unsplash.com/photo-1654263937079-f63a3ea4d48b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxyZXRhaWwlMjBjYXJkJTIwcGF5bWVudCUyMHRhcHxlbnwwfHx8fDE3OTE0NTcwOTh8MA&ixlib=rb-4.1.0&q=85",
  loyalty:
    "https://images.unsplash.com/photo-1509017174183-0b7e0278f1ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxyZXRhaWwlMjBjYXJkJTIwcGF5bWVudCUyMHRhcHxlbnwwfHx8fDE3OTE0NTcwOTh8MA&ixlib=rb-4.1.0&q=85",
};
